import React from "react";

interface ProductDetailItem {
    label: string;
    value: string;
}

interface ProductDetailsProps {
    details: ProductDetailItem[];
    title?: string;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({
    details,
    title = "Product Details",
}) => {
    return (
        <div className="mt-4 border-t border-slate-100 pt-5 w-full">
            {title && (
                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-900 mb-4">
                    {title}
                </h3>
            )}

            {/* Responsive Layout Matrix */}
            <div className="grid grid-cols-1 sm:grid-cols-1 gap-x-6 gap-y-3 text-xs md:text-sm">
                {details.map((item, index) => (
                    <div 
                        key={index} 
                        className="flex justify-between items-center py-2 border-b border-slate-50 sm:border-none"
                    >
                        <span className="font-medium text-slate-400">
                            {item.label}
                        </span>
                        <span className="font-semibold text-slate-800 text-right">
                            {item.value}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductDetails;